

import { Store } from 'lucide-react';
import { create } from 'zustand';

export interface RealtimeSOS {
  id: string;
  [key: string]: any;
}

export interface RealtimeIncident {
  id: string;
  [key: string]: any;
}

export interface LiveGuard {
  id: string;
  [key: string]: any;
}

export interface LiveSupervisor {
  id: string;
  [key: string]: any;
}

interface RealtimeState {
  activeSOS: RealtimeSOS[];
  incidents: RealtimeIncident[];

  liveGuards: LiveGuard[];
  liveSupervisors: LiveSupervisor[];

  upsertSOS: (sos: RealtimeSOS) => void;
  removeSOS: (id: string) => void;

  upsertIncident: (
    incident: RealtimeIncident
  ) => void;

  updateGuard: (guard: LiveGuard) => void;

  updateSupervisor: (
    supervisor: LiveSupervisor
  ) => void;

  clearRealtime: () => void;
}

export const useRealtimeStore =
  create<RealtimeState>((set) => ({
    activeSOS: [],
    incidents: [],

    liveGuards: [],
    liveSupervisors: [],

    upsertSOS: (sos) =>
      set((state) => {
        const exists =
          state.activeSOS.some(
            (x) => x.id === sos.id
          );

        return {
          activeSOS: exists
            ? state.activeSOS.map((x) =>
                x.id === sos.id ? sos : x
              )
            : [sos, ...state.activeSOS],
        };
      }),

    removeSOS: (id) =>
      set((state) => ({
        activeSOS: state.activeSOS.filter(
          (x) => x.id !== id
        ),
      })),

    upsertIncident: (incident) =>
      set((state) => {
        const exists =
          state.incidents.some(
            (x) => x.id === incident.id
          );

        return {
          incidents: exists
            ? state.incidents.map((x) =>
                x.id === incident.id
                  ? incident
                  : x
              )
            : [incident, ...state.incidents],
        };
      }),

    updateGuard: (guard) =>
      set((state) => {
        const exists =
          state.liveGuards.some(
            (g) => g.id === guard.id
          );

        return {
          liveGuards: exists
            ? state.liveGuards.map((g) =>
                g.id === guard.id ? guard : g
              )
            : [...state.liveGuards, guard],
        };
      }),

    updateSupervisor: (supervisor) =>
      set((state) => {
        const exists =
          state.liveSupervisors.some(
            (s) => s.id === supervisor.id
          );

        return {
          liveSupervisors: exists
            ? state.liveSupervisors.map((s) =>
                s.id === supervisor.id
                  ? supervisor
                  : s
              )
            : [
                ...state.liveSupervisors,
                supervisor,
              ],
        };
      }),

    clearRealtime: () =>
      set({
        activeSOS: [],
        incidents: [],
        liveGuards: [],
        liveSupervisors: [],
      }),
  }));